<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div style="padding:6px 15px; ">
			<Form ref="searchForm" :model="searchForm" label-position="left" :label-width="70" inline>
				<FormItem label="订单编号"><Input type="text" v-model="searchForm.orderid" placeholder="订单编号" /></FormItem>
				<FormItem label="订单类型">
					<Select v-model="searchForm.type" clearable>
						<Option value="jcz">预约检测站</Option>
						<Option value="mj">免检</Option>
						<Option value="dj">代驾</Option>
					</Select>
				</FormItem>
				<FormItem label="订单来源">
					<Select v-model="searchForm.source" clearable>
						<Option value="xcx">小程序</Option>
						<Option value="admin">后台</Option>
					</Select>
				</FormItem>
				<FormItem label="订单状态">
					<Select v-model="searchForm.state" clearable>
						<Option value="0">待支付</Option>
						<Option value="1">待派单</Option>
						<Option value="2">待处理</Option>
						<Option value="3">待服务</Option>
						<Option value="4">服务中</Option>
						<Option value="5">已处理</Option>
						<Option value="6">已完成</Option>
						<Option value="9">已取消</Option>
					</Select>
				</FormItem>
				<FormItem label="评价状态">
					<Select v-model="searchForm.rate" clearable>
						<Option value="1">已评价</Option>
						<Option value="0">未评价</Option>
					</Select>
				</FormItem>
				<FormItem label="车牌号码">
					<Input type="text" v-model="searchForm.chepai" placeholder="车牌" />
				</FormItem>
				<FormItem label="服务师傅">
					<Select
					placeholder="姓名或手机号搜索" clearable
					                v-model="searchForm.sf"
					                filterable
					                remote
					                :remote-method="get_sflist"
					                :loading="loading_sflist">
					                <Option v-for="(option, index) in sflist" :value="option.uid" :key="index">{{option.nickname}}({{option.mobile}})</Option>
					            </Select>
				</FormItem>
					<FormItem label="下单时间">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="add_date" placeholder="下单时间" split-panels v-model="searchForm.adddate"></DatePicker>
					</FormItem>
					<FormItem label="检车时间">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="search_jc_date" placeholder="检车时间" split-panels v-model="searchForm.jcdate"></DatePicker>
					</FormItem>
					<FormItem label="派单时间">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="searchDate('pdtime')" placeholder="派单时间" split-panels v-model="searchForm.pdtime"></DatePicker>
					</FormItem>
					<FormItem label="确认时间">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="searchDate('qrtime')" placeholder="确认时间" split-panels v-model="searchForm.qrtime"></DatePicker>
					</FormItem>
					<FormItem label="开始时间">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="searchDate('begintime')" placeholder="开始时间" split-panels v-model="searchForm.begintime"></DatePicker>
					</FormItem>
					<FormItem label="结束时间">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="searchDate('finishtime')" placeholder="结束时间" split-panels v-model="searchForm.finishtime"></DatePicker>
					</FormItem>
					<FormItem label="审核时间">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="searchDate('shtime')" placeholder="审核时间" split-panels v-model="searchForm.shtime"></DatePicker>
					</FormItem>
					<FormItem label="取消时间">
						<DatePicker type="daterange" format="yyyy-MM-dd" @on-change="searchDate('qxtime')" placeholder="取消时间" split-panels v-model="searchForm.qxtime"></DatePicker>
					</FormItem>
				<FormItem label="检测站">
					<Select v-model="searchForm.jcz" filterable clearable>
						<Option v-for="item in jczList" :value="item.id">{{item.name}}</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('searchForm')">
						<Icon type="ios-search" />
						搜索
					</Button>
				</FormItem>
				<FormItem>
					<Button type="default" @click="cleartiaojian('searchForm')">
						<Icon type="ios-search" />
						清空条件
					</Button>
				</FormItem>
			</Form>
		</div>
		<div class="padding-tb bg-white">
			
				<div class="flex justify-between">
					<div span="12">
						<div class="padding-left">
							<Button type="success" @click="showOrderAddModal=true" icon="ios-add">创建新订单</Button>
						</div>
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>
		</div>
		<Table :data="tableData2" :columns="tableColumns2" border :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row }" slot="type">
				<Tag color="primary" v-if="row.type == 'jcz'">检测站</Tag>
				<Tag color="success" v-else-if="row.type == 'mj'">免检</Tag>
				<Tag color="error" v-else-if="row.type == 'dj'">代驾</Tag>
			</template>
			<template slot-scope="{ row }" slot="state">
				<span class="text-red" v-if="row.stateflag == 0">待支付</span>
				<span class="text-orange" v-if="row.stateflag == 1">待派单</span>
				<span class="text-purple" v-if="row.stateflag == 2">待处理</span>
				<span class="text-mauve" v-if="row.stateflag == 3">待服务</span>
				<span class="text-blue" v-if="row.stateflag == 4">服务中</span>
				<span class="text-cyan" v-if="row.stateflag == 5">已服务</span>
				<span class="text-green" v-if="row.stateflag == 6">已完成</span>
				<span class="text-grey" v-if="row.stateflag == 9">已取消</span>
			</template>
			<template slot-scope="{ row }" slot="jsflag">
				<span v-if="row.stateflag == 6">
					<Tag color="red" v-if="row.jsflag == 0">未结算</Tag>
					<Tag color="success" v-else-if="row.jsflag == 1">已结算</Tag>
					<Tag color="default" v-else>未知</Tag>
				</span>
			</template>
			<template slot-scope="{ row }" slot="payflag">
				<span class="text-red" v-if="row.payflag == 0">未支付</span>
				<span class="text-green" v-else-if="row.payflag == 1">已支付</span>
				<span class="text-purple" v-else>未知</span>
			</template>
			<template slot-scope="{ row }" slot="chepai">
				<span class="chepai">{{ row.carinfo.plate_num_b }}</span>
			</template>
			<template slot-scope="{ row }" slot="money_str">
				<span class="text-red text-bold">{{ row.money_str }}</span>
			</template>
			<template slot-scope="{ row }" slot="action">
				<router-link tag="a" target="_blank" :to="{ path: 'view/' + row.orderid }">
					<Button type="primary">
						进入
						<Icon type="ios-arrow-forward" />
					</Button>
				</router-link>
			</template>

			<template slot="header">

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
		<Modal v-model="showOrderAddModal" title="创建新订单" @on-ok="orderAddSubmit('formOrderAdd')" :mask-closable="false"
		 footer-hide>
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formOrderAdd" :model="formOrderAdd" label-position="right" :label-width="100" label-colon>
					<FormItem label="订单类型">
						<RadioGroup v-model="formOrderAdd.type" type="button">
							<Radio label="jcz">检测站</Radio>
							<Radio label="dj">代驾</Radio>
							<Radio label="mj">免检</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="检测时间" v-if="formOrderAdd.type!='mj'">
						<DatePicker type="date" format="yyyy-MM-dd" placeholder="选择日期" @on-change="jc_date" :value="formOrderAdd.date"></DatePicker>
					</FormItem>
					<FormItem label="检测站" v-if="formOrderAdd.type=='jcz'">
						<Select v-model="formOrderAdd.jcz" filterable clearable>
							<Option v-for="item in jczList" :key="item.id" :value="item.id">[{{item.id}}{{item.province}}-{{item.city}}]{{item.name}}</Option>
						</Select>
					</FormItem>
					<FormItem label="取还车地址" v-if="formOrderAdd.type=='dj'">
						<Input type="textarea" v-model="formOrderAdd.fileds.add_qhc.address" :rows="2"></Input>
					</FormItem>
					<Divider orientation="left">车辆信息</Divider>
					<FormItem label="车牌">
						<Input v-model="formOrderAdd.carinfo.plate_num_b" maxlength="8" style="width:150px;"></Input>
					</FormItem>
					<FormItem label="使用性质">
						<RadioGroup v-model="formOrderAdd.carinfo.use_character">
							<Radio label="非营运" checked>非营运</Radio>
							<Radio label="营运">营运</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="座位数">
						<Select v-model="formOrderAdd.carinfo.passengers_num" clearable>
							<Option value="4">5座以下</Option>
							<Option value="5">5座</Option>
							<Option value="6">6座</Option>
							<Option value="7">7座</Option>
							<Option value="8">7座以上9座及以下</Option>
							<Option value="10">9座以上</Option>
						</Select>
					</FormItem>
					<FormItem label="注册日期">
						<DatePicker type="date" format="yyyy-MM-dd" @on-change="register_date" placeholder="选择注册日期" :value="formOrderAdd.carinfo.register_date"></DatePicker>
					</FormItem>
					<Tabs value="name1" type="card">
						<TabPane label="联系信息" name="name1">
							<FormItem label="姓名">
								<Input v-model="formOrderAdd.linkman.name" maxlength="18" style="width:150px;"></Input>
							</FormItem>
							<FormItem label="手机">
								<Input v-model="formOrderAdd.linkman.mobile" maxlength="11" show-word-limit style="width:200px;"></Input>
							</FormItem>
							<FormItem label="地址" v-if="formOrderAdd.type=='mj'">
								<Input type="textarea" v-model="formOrderAdd.linkman.address" :rows="2"></Input>
							</FormItem>
						</TabPane>
						<TabPane label="金额信息" name="name2">
							<FormItem label="订单金额">
								<Input v-model="formOrderAdd.money" style="width:120px;"></Input>
							</FormItem>
							<FormItem label="优惠金额">
								<Input v-model="formOrderAdd.money_yh" style="width:120px;"></Input>
							</FormItem>
							<FormItem label="支付状态">
								<RadioGroup v-model="formOrderAdd.payflag">
									<Radio label="0">未支付</Radio>
									<Radio label="1">已支付</Radio>
								</RadioGroup>
							</FormItem>
						</TabPane>
						<TabPane label="备注信息" name="name3">
							<Input v-model="formOrderAdd.remark" type="textarea" :rows="4" placeholder="" maxlength=140 show-word-limit />
						</TabPane>
					</Tabs>
					<Divider />
					<FormItem>
						<Button type="primary" @click="orderAddSubmit('formOrderAdd')" :loading="orderAddLoading" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="showOrderAddModal=false">取消</Button>
					</FormItem>
				</Form>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				jczList: [],
				state_arr: [],
				sflist:[],
				loading_sflist:false,
				showOrderAddModal: false,
				formOrderAdd: {
					type: "jcz",
					source: "",
					date: "",
					jcz: "",
					carinfo: {
						plate_num_b: "",
						use_character: "非营运",
						passengers_num: 4,
						register_date: ""
					},
					linkman: {
						name: "",
						mobile: "",
						address: ""
					},
					fileds: {
						add_qhc: {
							address: ""
						}
					},
					money: 0,
					money_yh: 0,
					payflag: "0",
					remark: ""
				},
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '类型',
						key: 'type_str',
						align: 'center',
						slot: 'type',
						width: 100
					},
					{
						title: '状态',
						key: 'state_str',
						align: 'center',
						slot: 'state',
						width: 90
					},
					{
						title: '结算',
						slot: 'jsflag',
						align: 'center',
						width: 100
					},
					{
						title: '金额',
						align: 'right',
						key: 'money_str',
						slot: 'money_str',
						width: 90
					},
					{
						title: '支付状态',
						slot: 'payflag',
						align: 'center',
						width: 110
					},
					{
						title: '车牌',
						slot: 'chepai',
						align: 'center',
						width: 150
					},
					{
						title: '检测站',
						key: 'jczinfo',
						width: 320
					},
					{
						title: '预约时间',
						key: 'date',
						align: 'center',
						width: 120
					},
					{
						title: '来源',
						key: 'source_str',
						align: 'center',
						width: 100
					},
					{
						title: '会员',
						key: 'user',
						align: 'center',
						width: 180
					},
					{
						title: '服务师傅',
						key: 'sf_str',
						align: 'center',
						width: 200
					},
					{
						title: '评价',
						key: 'rate',
						align: 'center',
						width: 90
					},
					{
						title: '提交时间',
						key: 'addtime',
						align: 'center',
						width: 190
					},
					{
						title: '操作',
						slot: 'action',
						fixed: 'right',
						width: 120
					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					orderid: '',
					source: '',
					chepai: '',
					sf:'',
					rate:''
				},
				orderAddLoading: false
			};
		},
		methods: {
			handleSubmit(name) {
				this.searchForm.page=1;
				this.loadinfos();
				return false;
			},
			cleartiaojian(name){
				this.searchForm= {
					page: 1,
					size: 20,
					total: 0,
					orderid: '',
					source: '',
					chepai: '',
					sf:'',
					rate:''
				};
				this.loadinfos();
				return false;
			},
			get_sflist(keyword){
				this.loading_sflist=true;
				this.$http.post('/server/api/order/index.php?a=sflist', this.$qs.stringify({keyword:keyword})).then(
					res => {
						this.loading_sflist = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.sflist = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading_sflist = false;
						this.$Message.error('系统错误');
					}
				);
			},
			add_date(date) {
				this.searchForm.adddate = date;
			},
			search_jc_date(date) {
				this.searchForm.jcdate = date;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/order/index.php?a=list', this.$qs.stringify(this.searchForm)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			},
			jc_date(date) {
				this.formOrderAdd.date = date;
			},
			register_date(date) {
				this.formOrderAdd.carinfo.register_date = date;
			},
			orderAddSubmit(name) {
				this.orderAddLoading = true;
				if (this.formOrderAdd.type != "mj") {
					if (!this.formOrderAdd.date) {
						this.$Message.error({
							background: true,
							content: "请选择检测时间",
							onClose: () => {
								this.orderAddLoading = false;
							}
						});
						return false;
					}
				}
				if (this.formOrderAdd.type == "jcz") {
					if (!this.formOrderAdd.jcz) {
						this.$Message.error({
							background: true,
							content: "请选择检测站",
							onClose: () => {
								this.orderAddLoading = false;
							}
						});
						return false;
					}
				}
				if (this.formOrderAdd.type == "dj") {
					if (!this.formOrderAdd.fileds.add_qhc.address) {
						this.$Message.error({
							background: true,
							content: "填写取换车地址",
							onClose: () => {
								this.orderAddLoading = false;
							}
						});
						return false;
					}
				}
				if (!this.formOrderAdd.carinfo.plate_num_b) {
					this.$Message.error({
						background: true,
						content: "填写车牌号码",
						onClose: () => {
							this.orderAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formOrderAdd.carinfo.passengers_num) {
					this.$Message.error({
						background: true,
						content: "请选择座位数",
						onClose: () => {
							this.orderAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formOrderAdd.carinfo.register_date) {
					this.$Message.error({
						background: true,
						content: "请选择注册日期",
						onClose: () => {
							this.orderAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formOrderAdd.linkman.name) {
					this.$Message.error({
						background: true,
						content: "请填写联系人姓名",
						onClose: () => {
							this.orderAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formOrderAdd.linkman.mobile) {
					this.$Message.error({
						background: true,
						content: "请填写联系人手机号",
						onClose: () => {
							this.orderAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formOrderAdd.linkman.address && this.formOrderAdd.type == "mj") {
					this.$Message.error({
						background: true,
						content: "请填写邮寄地址",
						onClose: () => {
							this.orderAddLoading = false;
						}
					});
					return false;
				}
				this.$Spin.show();
				this.$http.post('/server/api/order/index.php?a=add', this.$qs.stringify(this.formOrderAdd)).then(
					res => {
						this.$Spin.hide();
						if (res.data.result == 'ok') {
							this.$Message.success({
								background: true,
								content: "新建订单成功!",
								onClose: () => {
									this.$router.push("/order/view/" + res.data.data.orderid);
								}
							});
						} else {
							this.orderAddLoading = false;
							this.$Modal.error({
								title: '创建订单失败',
								content: res.data.msg
							});
						}
					},
					r => {
						this.$Spin.hide();
						this.$Message.error('系统错误');
					}
				);
				return false;
			}
		},
		created() {
			//console.log(this.searchForm)
			if(sessionStorage.getItem("order_searchForm")){
				this.searchForm=JSON.parse(sessionStorage.getItem("order_searchForm"));
			}
			this.loading = true;
			this.$http.post('/server/api/order/index.php?a=init').then(
				res => {
					this.loading = false;
					if (res.data.result == 'ok') {
						//this.$Message.success('获取成功!');
						this.jczList = res.data.data.jczList;
						this.state_arr = res.data.data.state_arr;
						this.loadinfos();
					} else {
						this.$Message.error(res.data.msg);
					}
				},
				r => {
					this.loading = false;
					this.$Message.error('系统错误');
				}
			);
		},
		destroyed:function(){
			sessionStorage.setItem("order_searchForm",JSON.stringify(this.searchForm));
		}
	};
</script>

<style>
	.chepai {
		display: inline-block;
		padding: 3px 8px;
		border-radius: 3px;
		background: #0081ff;
		color: #ffffff;
		line-height: 24px;
	}
</style>
